import { render, staticRenderFns } from "./KpisFornecedor.vue?vue&type=template&id=3cb31b08&scoped=true&"
import script from "./KpisFornecedor.vue?vue&type=script&lang=js&"
export * from "./KpisFornecedor.vue?vue&type=script&lang=js&"
import style0 from "./KpisFornecedor.vue?vue&type=style&index=0&id=3cb31b08&lang=scss&scoped=true&"
import style1 from "./KpisFornecedor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb31b08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VCol,VRow,VSimpleTable})
